export default __webpack_public_path__ + "static/sig_compare_comp2_active-736e4214bb8298c7337def62aef6976f.png";